import { NAVIGATIONS_CATEGORY } from "@/config/const";

const _navigationsCategory = NAVIGATIONS_CATEGORY;

export default {
  data() {
    return {
      navigationsCategory: _navigationsCategory,
    };
  },
  methods: {
    getNavigationsCategoryIds() {
      let ids = [];
      Object.keys(_navigationsCategory).forEach((key) => {
        ids.push(_navigationsCategory[key]);
      });
      return ids.map((item) => String(item));
    },
  },
};
